import React from 'react';
import type { ReactNode } from 'react';
import {
  ApartmentOutlined,
  ApiOutlined,
  AppstoreOutlined,
  BankOutlined,
  BranchesOutlined,
  ClearOutlined,
  CloudServerOutlined,
  CloudSyncOutlined,
  CodeOutlined,
  CommentOutlined,
  ControlOutlined,
  DashboardOutlined,
  ExperimentOutlined,
  FileSearchOutlined,
  FileTextOutlined,
  GlobalOutlined,
  IdcardOutlined,
  InboxOutlined,
  KeyOutlined,
  MailOutlined,
  MessageOutlined,
  MonitorOutlined,
  NodeIndexOutlined,
  PartitionOutlined,
  PhoneOutlined,
  RobotOutlined,
  RocketOutlined,
  SafetyCertificateOutlined,
  SafetyOutlined,
  ScheduleOutlined,
  SendOutlined,
  ShopOutlined,
  SnippetsOutlined,
  SwapOutlined,
  SyncOutlined,
  TableOutlined,
  TeamOutlined,
  UserOutlined,
  UsergroupAddOutlined,
  UserSwitchOutlined,
  WechatOutlined,
} from '@ant-design/icons';

/**
 * 侧边栏 / 页头图标统一映射。
 * key 与 MainLayout 菜单项 key 保持一致。
 */
const MENU_ICON_MAP: Record<string, ReactNode> = {
  // ── 租户与平台 ──
  tenant: <ApartmentOutlined />,
  'tenant-management': <TeamOutlined />,
  user: <UserOutlined />,
  'sync-manager': <SyncOutlined />,

  // ── 服务与运维 ──
  'service-management': <CloudServerOutlined />,
  server: <ApiOutlined />,
  'health-check-logs': <SafetyCertificateOutlined />,
  'deployment-management': <RocketOutlined />,

  // ── 任务 / 同步作业 ──
  job: <ScheduleOutlined />,
  'instruction-sync': <FileTextOutlined />,
  'modeling-sync': <PartitionOutlined />,
  'sql-pair-sync': <CodeOutlined />,

  // ── 权限 ──
  'role-permissions': <SafetyOutlined />,
  'role-permissions-manager': <TeamOutlined />,
  'user-permissions-manager': <UserSwitchOutlined />,
  'permissions-manager': <KeyOutlined />,
  'permission-switch-config': <ControlOutlined />,

  // ── 数据资产 ──
  instructions: <FileTextOutlined />,
  'sql-pairs': <CodeOutlined />,
  modeling: <PartitionOutlined />,
  template: <SnippetsOutlined />,
  mcp: <NodeIndexOutlined />,

  // ── 连接器 ──
  connector: <PhoneOutlined />,
  'connector-group': <DashboardOutlined />,
  'connector-monitor': <MonitorOutlined />,
  'whatsapp-group': <MessageOutlined />,
  'whatsapp-partners': <ShopOutlined />,
  'whatsapp-accounts': <UsergroupAddOutlined />,
  'account-mappings': <SwapOutlined />,
  'whatsapp-messages': <CommentOutlined />,
  'whatsapp-test': <SendOutlined />,

  // ── Agent ──
  'agent-group': <RobotOutlined />,
  agents: <RobotOutlined />,
  'agent-conversations': <WechatOutlined />,
  'agent-messages': <CommentOutlined />,
  'agent-workflow': <NodeIndexOutlined />,
  'ibuild-proxy-group': <CloudSyncOutlined />,
  'ibuild-proxy-agent': <RobotOutlined />,
  'ibuild-proxy-data': <TableOutlined />,
  'ibuild-proxy-mq': <BranchesOutlined />,
  'ibuild-proxy-cleanup': <ClearOutlined />,

  // ── 原始消息 ──
  'rowmessage-group': <InboxOutlined />,
  'raw-messages': <FileSearchOutlined />,

  // ── 组织 ──
  'organization-management': <TeamOutlined />,
  'employee-management': <IdcardOutlined />,
  'company-management': <BankOutlined />,

  // ── 其他 ──
  'test-agent': <ExperimentOutlined />,
  'email-config': <MailOutlined />,
  'user-profile': <UserOutlined />,
  settings: <ControlOutlined />,
  'i18n-test': <GlobalOutlined />,
};

/** 根据菜单 key 获取图标，未配置时回退为 AppstoreOutlined */
export function getMenuIcon(key: string): ReactNode {
  return MENU_ICON_MAP[key] ?? <AppstoreOutlined />;
}
